import { Component, OnInit } from '@angular/core';
import { UserService } from '@app/services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main-sidebar',
  templateUrl: './main-sidebar.component.html',
  styleUrls: ['./main-sidebar.component.scss']
})
export class MainSidebarComponent implements OnInit {

  public menuItems = [
    {
      title: 'Home',
      path: '/start',
      iconClass: 'fas fa-home',
    },
    {
      title: 'Aufgaben',
      path: '/aufgaben',
      iconClass: 'fas fa-tasks',
    },
    {
      title: 'Firmen/Standorte',
      path: '/firmen',
      iconClass: 'fas fa-map-marker-alt',
    },
  ]
  constructor (public readonly userService: UserService, public router: Router) {

  }

  ngOnInit(): void {}
}
